import { Box, Grid, Paper, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import { WsButton, WsColors, WsTypoColors, WsTypography } from 'wisestep-base';

export interface WsFilterDialogProps {
  children?: React.ReactNode;
  disabled?: boolean;
  onStartUpload?: () => void;
  open?: boolean;
  buttonType?: 'submit' | 'button' | undefined;
}
const UploadProgressPanel = styled(Box)(() => ({
  height: '400px',
  width: '350px',
  paddingBottom: '16px',
  position: 'fixed',
  bottom: '0px',
  right: '4px',
  zIndex: 1290,
}));

const UploadPopup = ({
  children,
  disabled = false,
  onStartUpload,
  open = false,
  buttonType = undefined,
}: WsFilterDialogProps) => {
  const [openUploadProgress, setUploadProgress] = useState<boolean>(open);
  const handleClickOpen = () => {
    if (onStartUpload) {
      onStartUpload();
    }
    setUploadProgress(true);
  };
  useEffect(() => setUploadProgress(open), [open]);
  return (
    <Box>
      <WsButton type={buttonType} onClick={handleClickOpen} disabled={disabled}>
        Start Upload
      </WsButton>
      {openUploadProgress && (
        <UploadProgressPanel component={Paper}>
          <Grid container item xs={12} p={2} bgcolor={WsColors.TheBlues900}>
            <WsTypography color={WsTypoColors.WHITE}>File Upload</WsTypography>
          </Grid>
          <Box mb={2} height="400px" sx={{ overflow: 'hidden', overflowY: 'scroll' }}>
            {children}
          </Box>
        </UploadProgressPanel>
      )}
    </Box>
  );
};

export default UploadPopup;
